export const environment = {
  production: true,
  name: 'PRO',
  PackagingUrl: 'https://api-packaging-pro-a2d8fch6dda4ehdt.westeurope-01.azurewebsites.net',
  cacheInMin: 30,
  appInsights: {
    enableAppInsights: false,
  },
  maintenanceMode: false,
  enableDownloadSection: false,
};
